import styled, { css } from 'styled-components';

import { SPACE } from '../../../../theme/tokens';

/**
 * Holds the sliding content under the section's header, the area header or, with the `website-hub` flag off, the tab
 * row (the hook's anchor for scrolling a new tab to the top). The slide clips sideways, so it bleeds across the page's
 * 16px gutter (Column pads it back): the clip edge is the page's own edge, as on any route, and whatever a tab draws a
 * little past the column (the styles strip's selection ring, card shadows) is not cut at the column's edge.
 */
export const Content = styled.div<{ $backHeader: boolean }>`
  min-width: 0;
  margin: 0 -${SPACE[16]};

  /* While the area header (BackHeader) pins above the content, a page's own pinned rows (Game Lists' filter and
     actions) pin that much lower, under it rather than over it: its whole pinned box, the title's line (18px at a
     1.4 line height) and the 20px fade tail under it, so the tail neither tints those rows nor takes their clicks. */
  ${({ $backHeader }) =>
    $backHeader &&
    css`
      --ows-back-header-offset: 45px;
    `}
`;

/** The open tab's sections, laid out like the page column they used to sit in directly (PageShell's 16px gap). */
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
  min-width: 0;
  padding: 0 ${SPACE[16]};
`;

/* The area header's slot for the open area's action (see `useWebsiteHeaderAction`): the page draws into it, at the
   right of the row; across it where the row is one of its own (on a phone), so a page can lay out the whole row. */
export const HeaderActionSlot = styled.span`
  display: inline-flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-items: center;
  min-width: 0;
`;
